// @ts-nocheck
import { Component } from "@theme/component";
/**
 *
 * @typedef {object} Refs
 * @property {HTMLDivElement} tabliteContainer - The container element for the Tablite widget.
 * @extends {Component<Refs>}
 */
class TabliteBooking extends Component {
  requiredRefs = ["tabliteContainer"];
  get country() {
    return this.dataset.country;
  }
  get language() {
    return this.dataset.language;
  }
  get privacyPolicyUrl() {
    return this.dataset.privacyPolicyUrl;
  }
  get storeLocatorUrl() {
    return this.dataset.storeLocatorUrl;
  }

  connectedCallback() {
    super.connectedCallback();
    this.initTablite();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
  }

  /**
   * @param {object} data
   */
  initTablite(data) {
    const urlParams = new URLSearchParams(window.location.search);
    const storeNumber = urlParams.get("storeNumber");
    const storeBrandName = urlParams.get("storeBrandName");
    const updateAppointment = urlParams.get("updateAppointment") === "true";
    const cancelAppointment = urlParams.get("cancelAppointment") === "true";

    const widgetConfig = {
      selector: "#" + this.refs.tabliteContainer.id,
      lang: this.language,
      linkPrivacyPolicy: this.privacyPolicyUrl,
      storeLocatorLink: this.storeLocatorUrl,
      updateAppointment: updateAppointment,
      cancelAppointment: cancelAppointment,
      brand: this.getBrandCode(storeBrandName),
      storeNumber: storeNumber,
      country: this.country,
      advancedAnalytics: true,
      notesConfig: { required: false, visible: true },
      phoneNumberConfig: { required: true, visible: true },
      birthdateConfig: { required: true, visible: true },
      calendarStartDayIsMonday:
        this.country !== "US" && this.country !== "CA" && this.country !== "AU",
    };
    if (updateAppointment || cancelAppointment) {
      widgetConfig.appointmentId = urlParams.get("appointmentId");
    }

    if (this.dataset.langUrl) {
      widgetConfig.langUrl = this.dataset.langUrl;
    }

    //console.log("Tablite widgetConfig:", widgetConfig);

    const tabliteWidget = TabLt.tabWidget.new(widgetConfig);

    tabliteWidget.render();
  }

  getBrandCode(brandName) {
    const brandMap = {
      LensCrafters: "LC",
      "Target Optical": "TO",
      "Pearle Vision": "PV",
      "For Eyes": "FE",
      "Salmoiraghi & Viganò": "SV",
      GrandVision: "GV",
    };
    return brandMap[brandName] || "";
  }
}

if (!customElements.get("tablite-booking")) {
  customElements.define("tablite-booking", TabliteBooking);
}
